<template>
  <DeleteConfirm
      itemKey="Account"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :deleteData="deleteData"
      @onDelete="(response) => $emit('onDelete', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import Accounts from '@/services/accounts'

  import DeleteConfirm from '@/components/_Part/_Modal/_Confirm/Delete'

  export default {
    name: 'Delete',
    props: [
      'id'
    ],
    emits: [
      'onDelete'
    ],
    components: {
      DeleteConfirm
    },
    methods: {
      fetchData() {
        return Accounts
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Odstrániť účet "' + Item.billingName + '"'
      },
      setQuestion(Item) {
        return 'Naozaj chcete odstrániť účet "' + Item.billingName + '"?'
      },
      deleteData() {
        return Accounts
          .delete({
            id: this.id
          })
      }
    }
  }
</script>
